import {AchievementFiles} from "./AchievementFiles";

export class Hobbies {
  sports_section: number = null;
  national_sport_types: number = null;
  interests_clubs: number = null;
  creative_circles: number = null;
  sports_section_files: AchievementFiles[] = [];
  national_sport_types_files: AchievementFiles[] = [];
  interests_clubs_files: AchievementFiles[] = [];
  creative_circles_files: AchievementFiles[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/personal-achievements/Hobbies.ts